/**
 * "(optional)" after a field label (design system › FormField: mark the
 * optional fields, not the required ones, so no asterisks).
 */
export function Optional() {
  return <span className="ml-1 font-normal text-gray-500">(optional)</span>;
}
